export default __webpack_public_path__ + "static/media/question-mark.85815bf5.png";